import { render, staticRenderFns } from "./RequestCenterComponent.vue?vue&type=template&id=74c99ca6&lang=pug&"
import script from "./RequestCenterComponent.vue?vue&type=script&lang=js&"
export * from "./RequestCenterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports